module.exports = __webpack_public_path__ + "static/img/login-img.01a9e5a0.png";